var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{attrs:{"size":_vm.size,"disabled":_vm.disabled},on:{"mouseover":_vm.over,"mouseleave":_vm.leave,"click":_vm.clickEvent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }